import { CanvasJSON } from '@doer/frontend-components/creativity-editor';
import { ESPN_HEROS_BASE_URL } from '../urls';

export const espnHero3840x1280: CanvasJSON = {
  version: '7.1.0',
  objects: [
    {
      cropX: 0,
      cropY: 0,
      pieceId: 'background',
      type: 'Image',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 1920,
      top: 640,
      width: 3840,
      height: 1280,
      fill: 'rgb(0,0,0)',
      stroke: null,
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 1,
      scaleY: 1,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0,
      src: `${ESPN_HEROS_BASE_URL}/ligue1/backgrounds/3840x1280.png`,
      crossOrigin: 'anonymous',
      filters: [],
      selectable: false,
      evented: false
    },
    {
      cropX: 0,
      cropY: 0,
      pieceId: 'player-0',
      type: 'Image',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 1945.6252,
      top: 983.9605,
      width: 2048,
      height: 2048,
      fill: 'rgb(0,0,0)',
      stroke: null,
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 1.0589,
      scaleY: 1.0589,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0,
      src: `${ESPN_HEROS_BASE_URL}/ligue1/as-monaco/ansu-fati/ansu-fati-002.png`,
      crossOrigin: 'anonymous',
      filters: []
    },
    {
      cropX: 0,
      cropY: 0,
      pieceId: 'player-3',
      type: 'Image',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 3392.9671,
      top: 984.2624,
      width: 2048,
      height: 2048,
      fill: 'rgb(0,0,0)',
      stroke: null,
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 1.0612,
      scaleY: 1.0612,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0,
      src: `${ESPN_HEROS_BASE_URL}/ligue1/auxerre/francisco-sierralta/francisco-sierralta-002.png`,
      crossOrigin: 'anonymous',
      filters: []
    },
    {
      cropX: 0,
      cropY: 0,
      pieceId: 'player-2',
      type: 'Image',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 2883.703,
      top: 978.8054,
      width: 2048,
      height: 2048,
      fill: 'rgb(0,0,0)',
      stroke: null,
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 1.0647,
      scaleY: 1.0647,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0,
      src: `${ESPN_HEROS_BASE_URL}/ligue1/auxerre/diomande-sinaly/diomande-sinaly-005.png`,
      crossOrigin: 'anonymous',
      filters: []
    },
    {
      cropX: 0,
      cropY: 0,
      pieceId: 'player-1',
      type: 'Image',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 2417.8315,
      top: 978.7878,
      width: 2048,
      height: 2048,
      fill: 'rgb(0,0,0)',
      stroke: null,
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 1.0605,
      scaleY: 1.0605,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0,
      src: `${ESPN_HEROS_BASE_URL}/ligue1/as-monaco/golovin-aleksandr/golovin-aleksandr-004.png`,
      crossOrigin: 'anonymous',
      filters: []
    }
  ],
  background: '#f0f0f0'
};
